import ExportBase from "../exportbase";


import LabelDialog from "../../../../../dialogs/labeldialog";
import DialogInput from "../../../../../dialogs/input";
import DialogInputBox from "../../../../../dialogs/inputbox";
import RadioInput from "../../../../../dialogs/radioinput";

import SelectSequence from "../../../sequences/selectsequence/selectsequence";

import React from "react";

import { getCurrentUserDatas } from "../../../../../../utils/software";
import { getCurrentProjectDatas } from "../../../../../../utils/software";

import { apiReadOneAsset } from "../../../../../../utils/apis";

class ExportTTML extends ExportBase
{


constructor(props)
{
    super(props);

    this.state.formulaire =
    {
        originalprogram: "",
        translatedprogram:"",
        originalepisode:"",
        translatedepisode:"",  
        translatorname:"",
        translatordetails:"",
        referencecode:"",
        open:"0",
        sequences: false,
        
    }
        
    this.sequenceid = 0;
    this.sequencesAsset = {};
    this.level2Ref = React.createRef();
    this.openRef = React.createRef();

    this.sequenceRef = React.createRef();

    this.originalprogramRef = React.createRef();
    this.translatedprogramRef = React.createRef();
    this.originalepisodeRef = React.createRef();
    this.translatedepisodeRef = React.createRef();

    this.translatornameRef = React.createRef();
    this.translatordetailsRef = React.createRef();
    this.referencecodeRef = React.createRef();



    this.onAssetDownloaded = this.onAssetDownloaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)


    this.ready = false;
    this.lastFormulaireSend = "";

    this.onClickOnSequence = this.onClickOnSequence.bind(this);
    this.readSequenceCallBack = this.readSequenceCallBack.bind(this);


}

componentDidMount()
{
    super.componentDidMount();
}

componentDidUpdate()
{
    super.componentDidUpdate()
}

onClickOnSequence(item, index)
{
    
    this.sequencesAsset = item;
    this.sequenceDatas = null;
    this.sequenceid = 0;

    this.sendFormulaire();

    // on lit l'asset

    const datas = {asid: item.asid};
    apiReadOneAsset(datas, this.readSequenceCallBack)

}

readSequenceCallBack(datas)
{
    if (datas.ret)
    {
        
        this.sequenceDatas = JSON.parse(datas.asdatas);
        this.sequenceid = datas.asid;

        

        this.sendFormulaire();
    }
}

createWorker()
{

    
    
    if ((this.sequenceRef.current.getValue()) && (this.sequenceid<1))
        return null;
    return new Worker(new URL('./ttmlworker.js', import.meta.url));
}

sendFormulaire()
{
    var datas = {};

    datas.open = this.openRef.current.getValue();

    datas.formulaire  = {};
    datas.formulaire.originalprogram = this.originalprogramRef.current.getValue();
    datas.formulaire.originalepisode = this.originalepisodeRef.current.getValue();
    datas.formulaire.translatedprogram = this.translatedprogramRef.current.getValue();
    datas.formulaire.translatedepisode = this.translatedepisodeRef.current.getValue();


    datas.formulaire.translatorname = this.translatornameRef.current.getValue();
    datas.formulaire.translatordetails = this.translatordetailsRef.current.getValue();
    datas.formulaire.referencecode = this.referencecodeRef.current.getValue();

    datas.formulaire.sequences = this.sequenceRef.current.getValue();
    datas.formulaire.sequenceid = this.sequenceid;

    if (this.lastFormulaireSend !== JSON.stringify(datas))
    {
        this.lastFormulaireSend = JSON.stringify(datas);
        {
            datas.formulaire.sequenceDatas = this.sequenceDatas;
            this.startComputeFile(datas)
        }
    }

    
    
}


handleOnChange()
{
    if (this.ready) this.sendFormulaire();
};

onAssetDownloaded(asset)
{

    var formulaire = this.state.formulaire;
    
    formulaire.originalprogram = asset.astitle;
    formulaire.originalepisode = asset.astitle;

    formulaire.translatorname = getCurrentUserDatas().datas.firstname+" "+getCurrentUserDatas().datas.lastname;
    formulaire.translatordetails = getCurrentUserDatas().datas.email;
    formulaire.referencecode = getCurrentProjectDatas().pjsherlock;

    


    this.setState({formulaire: formulaire})

    if ((this.originalprogramRef) && (this.originalprogramRef.current))
    {

        this.originalprogramRef.current.setValue(asset.astitle)
        this.originalepisodeRef.current.setValue(asset.astitle)

        this.translatornameRef.current.setValue (formulaire.translatorname);
        this.translatordetailsRef.current.setValue (formulaire.translatordetails)
        this.referencecodeRef.current.setValue(formulaire.referencecode)
    }

    
    this.ready = true;

}

render()

{
    // <>{this.props.format}<br/>{this.props.type}<br/>{this.props.title}<br/>{this.props.asid}</>

    return super.render(

    <>
        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Type de fichier":"File type"}
        />

        <RadioInput value={this.state.formulaire.open}
            title1={this.context.language=="fr"?"Exporter en sous-titrage télétexte (closed)":"Télétexte Export"}
            title2={this.context.language=="fr"?"Exporter en sous-titrage classique (Open)":"Open export"}
            ref = {this.openRef}
            onChange =  {this.handleOnChange}
            />

        <br/>

        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Séquences":"Sequences"}
        />

        <DialogInputBox
        value = {this.state.formulaire.sequences}
        disabled={false}
        autoFocus = {false}
        ref = {this.sequenceRef}
        onChange =  {this.handleOnChange}
        
        title = {this.context.language=="fr"?" Inclure les séquences : ":"With sequences :"}
        />

        <SelectSequence onClick = {this.onClickOnSequence} list = {this.props.assetsList}/>

        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Entête":"Header"}
        />

        <DialogInput
        value = {this.state.formulaire.originalprogram}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.originalprogramRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Titre original du programme":"Original program title"}
        />

        <DialogInput
        value = {this.state.formulaire.translatedprogram}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.translatedprogramRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Titre traduit du programme":"Translated program title"}
        />


        <DialogInput
        value = {this.state.formulaire.originalepisode}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.originalepisodeRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Titre original de l'épisode":"Original episode title"}
        />

        <DialogInput
        value = {this.state.formulaire.translatedepisode}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.translatedepisodeRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Titre traduit de l'épisode":"Translated episode title"}
        />


        <DialogInput
        value = {this.state.formulaire.translatorname}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.translatornameRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Nom du traducteur":"Translator's name"}
        />

        <DialogInput
        value = {this.state.formulaire.translatordetails}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.translatordetailsRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Coordonnées traducteur":"Translator's contact details"}
        />

        <DialogInput
        value = {this.state.formulaire.referencecode}
        disabled={false}
        onChange =  {this.handleOnChange}
        autoFocus = {false}
        ref = {this.referencecodeRef}
        readOnly = {false}
        width = "94%"
        title = {this.context.language=="fr"?"Code de référence sous-titres":"Subtitle list reference code"}
        />


        <br/>
        <br/>
        
    </>
        
    )
}
}

export default ExportTTML;